import React, { useState } from "react";
import RowColLayout from "./RowColLayout";

const DocRequirement = ({ value, onChange }) => {
  const [showInfo, setShowInfo] = React.useState(false);

  // This will determine if info should be shown based on "No" being selected
  const handleChange = (newValue) => {
    onChange?.(newValue);
    if (newValue === "no") {
      setShowInfo(true); // Show info only when "No" is selected
    } else {
      setShowInfo(false); // Hide info when "Yes" is selected
    }
  };

  return (
    <RowColLayout>
      <div
        role="button"
        className={`w-100 border rounded p-0 m-0 transition ${
          value === "no" ? "border-warning bg-warning-subtle" : ""
        }`}
      >
        {/* now we dont need all these, because there is a field in the form that shows this */}
        {/* <RowColLayout>
          <label className="text-center">
            <strong>¿Cuentas con una eTA vigente para Canadá?</strong>
          </label>
        </RowColLayout>
        <RowColLayout>
          <div className="p-0 m-0">
            <label>
              <input
                type="radio"
                name="eta"
                value="yes"
                checked={value === "yes"}
                onChange={() => handleChange("yes")}
              />{" "}
              Sí
            </label>

            <label style={{ marginLeft: "16px" }}>
              <input
                type="radio"
                name="eta"
                value="no"
                checked={value === "no"}
                onChange={() => handleChange("no")}
              />{" "}
              No
            </label>
            <span
              style={{ marginLeft: "8px", cursor: "pointer" }}
              title="Qué es la eTA?"
              onClick={() => setShowInfo(!showInfo)}  // Toggle info when clicking on ❓
            >
              ❓
            </span>
          </div>
        </RowColLayout> */}

        {/* but we need to show this info as its working right now */}
        {/* Always show this info regardless of Yes or No */}
        {showInfo || value === "no" ? (
          <div
            className="eta-info"
            style={{
              marginTop: "12px",
              borderLeft: "2px solid #ccc",
              paddingLeft: "8px",
              paddingTop: "8px", // Added padding for spacing
            }}
          >
            <h4>Qué es la eTA?</h4>
            <p>
              La eTA (Electronic Travel Authorization) es un permiso electrónico obligatorio para ingresar a Canadá por vía aérea.
            </p>
            <h4>¿Cómo se tramita?</h4>
            <p>
              Se solicita en línea, es rápida y generalmente se aprueba en minutos.{" "}
              <a href="https://www.canada.ca/eta" target="_blank" rel="noopener noreferrer">
                https://www.canada.ca/eta
              </a>
            </p>
          </div>
        ) : null}

        {/* Show additional info if "No" is selected */}
        {value === "no" && (
          <div
            className="eta-info"
            style={{
              marginTop: "12px",
              borderLeft: "2px solid #ccc",
              paddingLeft: "8px",
              paddingTop: "8px", // Added padding for spacing
            }}
          >
            <h4>Si no tienes una eTA, tramítala aquí:</h4>
            <p>
              <a href="https://www.canada.ca/eta" target="_blank" rel="noopener noreferrer">
                https://www.canada.ca/eta
              </a>
            </p>
            <h5>Requisitos importantes:</h5>
            <ul>
              <li>Contar con visa americana vigente</li>
              <li>Pasaporte vigente (mínimo 6 meses) para viajes internacionales</li>
            </ul>
          </div>
        )}
      </div>
    </RowColLayout>
  );
};

export default DocRequirement;
